import { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import * as Preact from 'preact';

import * as QrCode from './A_QrCode';

export interface Props {
    qrUrl?: string;
    loading: boolean;
    sx?: SxProps;
}

const typographyContainerSx: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
};

export const Component = (p: Props) => {
    return (
        <CardContent
            sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px !important',
                borderRadius: '8px',
                backgroundColor: '#FFFFFF',
                gap: '24px',
                boxSizing: 'border-box',
                ...p.sx,
            }}
        >
            {p.loading && (
                <>
                    <Box sx={{ ...typographyContainerSx }}>
                        <Typography variant="h6">Generating QR Code...</Typography>
                        <Typography variant="body2" color="text.secondary">
                            You’ll use this QR code to access Augmented R on your mobile device.
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', padding: '19px' }}>
                        <CircularProgress size={40} />
                    </Box>
                </>
            )}
            {p.qrUrl && (
                <>
                    <Box sx={{ ...typographyContainerSx }}>
                        <Typography variant="h6">Try it in your home</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Scan the QR Code with your mobile device and tap launch!
                        </Typography>
                    </Box>
                    <QrCode.Component url={p.qrUrl} size={78} />
                </>
            )}
        </CardContent>
    );
};

Component.displayName = 'ARDesktop';
